import MerriweatherWoff2 from "./merriweather-regular.woff2";
import MerriweatherWoff from "./merriweather-regular.woff";
import RobotoWoff2 from "./roboto-regular.woff2";
import RobotoWoff from "./roboto-Regular.woff";

export const merriweather = `
    font-family: 'Merriweather';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: local('Merriweather'), local('Merriweather-Regular'), url(${MerriweatherWoff}) format('woff'), url(${MerriweatherWoff2}) format('woff2');
    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF';
`

export const roboto =  `
  font-family: 'Roboto';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local('Roboto'), local('Roboto-Regular'), url(${RobotoWoff}) format('woff'), url(${RobotoWoff2}) format('woff2');
  unicodeRange:'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF';
`
